import { createSlice } from '@reduxjs/toolkit';
/**
 * У нас раньше избранное было только из экспонентов,
 * а затем понадобилось хранить еще и активности.
 * Будем проверять какой формат сохраненных данных у
 * пользователя и конвертируем, если надо.
 */
const checkFavorites = () => {
    let fav = localStorage.getItem('favorites') ?? '{}';

    try {
        fav = JSON.parse(fav);
        // Поминим что null имеет тип 'object'
        if(typeof fav !== 'object' || fav === null) throw new Error();
        for(let key in fav) {
            if(!fav.hasOwnProperty(key)) continue;
            if(!Array.isArray(fav[key])) continue;
            let exhibitors = fav[key];
            delete fav[key];
            fav[key] = { exhibitors, activities: [] };
        }
    } catch(error) {
        console.error('Ошибка конвертации избранного');
        fav = {};
    }

    localStorage.setItem('favorites', JSON.stringify(fav));
    return fav;
};

const initialList = checkFavorites();

export const favoritesSlice = createSlice({
    name: 'favorites',
    initialState: {
        isVisible: false,
        list: initialList,
    },
    reducers: {
        // Установка/сброс флага показа избранного
        favoritesShow: (state, action) => {
            state.isVisible = action.payload;
        },
        // Внесение в избранное экспонента
        favoritesAddExhibitor: (state, action) => {
            const exhibitor = action.payload; // объект экспонента
            const event = typeof exhibitor.event === 'string' ? exhibitor.event : exhibitor.event._id; // идентификатор мероприятия
            if(!state.list[event]) state.list[event] = { exhibitors: [], activities: [] };
            const index = state.list[event].exhibitors.findIndex(e => e._id === exhibitor._id);
            if(index < 0) {
                state.list[event].exhibitors.push(exhibitor);
            } else {
                state.list[event].exhibitors[index] = exhibitor;
            }
            localStorage.setItem('favorites', JSON.stringify(state.list));
        },
        // Удаление экспонента из избранного
        favoritesDelExhibitor: (state, action) => {
            const exhibitor = action.payload; // объект экспонента
            const event = typeof exhibitor.event === 'string' ? exhibitor.event : exhibitor.event._id; // идентификатор мероприятия
            if(!state.list[event]) return;
            const index = state.list[event].exhibitors.findIndex(e => e._id === exhibitor._id);
            if(index >= 0) state.list[event].exhibitors.splice(index, 1);
            localStorage.setItem('favorites', JSON.stringify(state.list));
        },
        // Внесение в избранное активности
        favoritesAddActivity: (state, action) => {
            const activity = action.payload; // объект активности
            const event = typeof activity.event === 'string' ? activity.event : activity.event._id; // идентификатор мероприятия
            if(!state.list[event]) state.list[event] = { exhibitors: [], activities: [] };
            const index = state.list[event].activities.findIndex(a => a._id === activity._id);
            if(index < 0) {
                state.list[event].activities.push(activity);
            } else {
                state.list[event].activities[index] = activity;
            }
            localStorage.setItem('favorites', JSON.stringify(state.list));
        },
        // Удаление активности из избранного
        favoritesDelActivity: (state, action) => {
            const activity = action.payload; // объект активности
            const event = typeof activity.event === 'string' ? activity.event : activity.event._id; // идентификатор мероприятия
            if(!state.list[event]) return;
            const index = state.list[event].activities.findIndex(a => a._id === activity._id);
            if(index >= 0) state.list[event].activities.splice(index, 1);
            localStorage.setItem('favorites', JSON.stringify(state.list));
        },
    },
});

export const {
    favoritesShow,
    favoritesAddActivity,
    favoritesAddExhibitor,
    favoritesDelActivity,
    favoritesDelExhibitor,
} = favoritesSlice.actions;
export default favoritesSlice.reducer;
